import React, { useState, useEffect, useMemo, } from 'react';
import 'font-awesome/css/font-awesome.min.css';
import '../../assets/stylesheet/layout.scss';
import Button from 'react-bootstrap/Button';
import { Nav, Tab, Row, Col } from 'react-bootstrap';
import Accordion from 'react-bootstrap/Accordion';
import '../../assets/stylesheet/conversationpreview.scss'
import SearchableSelect from '../../components/searchableSelect';
import DashedCircleProgressBar from '../../components/dashedcircleprogressbar';
// table-packege and data start
import { useLocation, useNavigate } from 'react-router-dom';
import queryString from 'query-string';
import ApiRequest from '../../services/apiService';
import { ShowToastUtil } from '../../utilities/showToastUtil';
import GetUserData from '../../utilities/getUserDetails';
import baseUrl from '../../services/baseUrl';
import GetFormattedDateTime from '../../utilities/getFormattedDateTime';
import ScreenLoader from '../../components/screenLoader';
import { TRUE } from 'sass';
// sample table data
const sampleData = [
    { id: 1, name: 'Collection Centre', NetPromoterScore: 69, Requests: 390189, SMSSent: { Invitations: 291706, Reminders: 10 }, EmailSent: { Invitations: 15, Reminders: 10 }, PeopleContacted: 252083, Responses: 13860, ResponseRate: 5.50, Promoters: 10217, Passives: 2986, Detractors: 657 },

];

const statusoptions = [
    { label: 'Open', value: 'Open' },
    { label: 'In-Progress', value: 'In-Progress' },
    { label: 'On-Hold', value: 'On-Hold' },
    { label: 'Closed', value: 'Closed' },
];

function FeedsPage() {

    const handleSelect = (option) => {
    };

    // page scroll to add effect    
    const [isScrolled, setIsScrolled] = useState(false);
    // Function to handle scroll event
    const handleScroll = () => {
        if (window.scrollY > 50) { // Adjust the value based on when you want to add the class
            setIsScrolled(true);
        } else {
            setIsScrolled(false);
        }
    };

    useEffect(() => {
        // Add scroll event listener
        window.addEventListener('scroll', handleScroll);
        // Cleanup event listener on component unmount
        return () => {
            window.removeEventListener('scroll', handleScroll);
        };
    }, []);


    const [setValue] = useState(null);



    // table configuration and option start
    const [searchTerm, setSearchTerm] = useState('');
    const [currentPage, setCurrentPage] = useState(0);
    const [itemsPerPage, setItemsPerPage] = useState(15);
    const [sortConfig, setSortConfig] = useState({ key: 'name', direction: 'ascending' });
    const [IsLoading, setIsLoading] = useState(false);
    const [projectFilter, setProjectFilter] = useState(localStorage.getItem('projectFilter') || '');

    const handleSearchChange = (e) => {
        setSearchTerm(e.target.value);
        setCurrentPage(0); // Reset to the first page on search
    };

    const handlePageClick = (event) => {
        setCurrentPage(event.selected);
    };

    const handleSort = (key) => {
        let direction = 'ascending';
        if (sortConfig.key === key && sortConfig.direction === 'ascending') {
            direction = 'descending';
        }
        setSortConfig({ key, direction });
    };

    const handlePageSizeChange = (e) => {
        setItemsPerPage(Number(e.target.value));
        setCurrentPage(0); // Reset to the first page on page size change
    };

    const sortedData = [...sampleData].sort((a, b) => {
        if (a[sortConfig.key] < b[sortConfig.key]) {
            return sortConfig.direction === 'ascending' ? -1 : 1;
        }
        if (a[sortConfig.key] > b[sortConfig.key]) {
            return sortConfig.direction === 'ascending' ? 1 : -1;
        }
        return 0;
    });

    const filteredData = sortedData.filter(item => {
        // Check if the search term is in any column
        const searchLower = searchTerm.toLowerCase();
        return Object.values(item).some(value =>
            String(value).toLowerCase().includes(searchLower)
        );
    });
    const paginatedData = filteredData.slice(
        currentPage * itemsPerPage,
        (currentPage + 1) * itemsPerPage
    );

    const CryptoJS = require('crypto-js');
    const secretKey = 'your-secret-key';
    const decryptData = (encryptedData, secretKey) => {
        const bytes = CryptoJS.AES.decrypt(encryptedData, secretKey);
        return bytes.toString(CryptoJS.enc.Utf8);
    };
    // table configuration and option end
    const [key, setKey] = useState('key-words');
    const location = useLocation();
    const query = queryString.parse(location.search);
    const userEmail = GetUserData().UserEmail;
    const [feedsData, setFeedsData] = useState({});

    const tempUid = useMemo(() => {
        if (query.tempid) {
            const decryptedUserId = decryptData(decodeURIComponent(query.tempid), secretKey);// secret key is not defned
            return JSON.parse(decryptedUserId);
        }
        return {};
    }, [query.tempid]);

    const [userInfo, setUserInfo] = useState(GetUserData());
    const fetchData = async (id) => {
        setIsLoading(true);
        try {
            const params = new URLSearchParams({
                userEmail: userEmail,
                id: id,
                isRead: 1,
                queryMode: 'transactionDetails',
                projectFilter: projectFilter.split(',') || ''
            });
            const url = `${baseUrl()}/nps/GetFeedsData?${params.toString()}`;
            const response = await ApiRequest({ apiLink: url, method: 'GET' });
            if (response.Message === 'Success') {
                setIsLoading(false);
                setFeedsData(response.Data.FeedData || {});
            } else {
                console.log('Failed to load data');
            }
        } catch (error) {
            console.error('Error fetching cloud data:', error);
        }
    };
    useEffect(() => {
        fetchData(tempUid)
    }, [tempUid]);

    const categoryColors = {
        6: "#f10000",
        10: "#008000",
        8: "#ffb62f"
    };
    const ratingFeedback = {
        6: "Would Not Recommend",
        10: "Highly Recommended",
        8: "Neutral"
    };

    const categoryScore = {
        6: 60,
        10: 100,
        8: 80
    };
    const navigate = useNavigate();

    const handleBackClick = () => {
        navigate(-1);
    };
    const [note, setNote] = useState('');
    const handleNotes = (e) => {
        setNote(e.target.value);
    };

   const isSuburban = userInfo?.Company?.toLowerCase() === "sdpl";
    const handleAddNotes = async () => {
        setIsLoading(true);
        try {
            const params = new URLSearchParams({
                // userName: userData.UserName,
                id: feedsData.Id,
                note: note,
                invoiceCode: feedsData.InvoiceAccount,
                npsType: feedsData.NpsType,
                queryMode: 'addNotes'
            });
            const url = `${baseUrl()}/nps/GetFeedsData?${params.toString()}`;
            const response = await ApiRequest({ apiLink: url, method: 'GET' });

            if (response.Message === 'Success') {
                setIsLoading(false);
                ShowToastUtil('Note added', 'success');
            } else {
                console.log('Failed to load data');
            }
        } catch (error) {
            console.error('Error fetching cloud data:', error);
        }
        window.location.reload();
    };
    const DateFormatter = (dateString) => {
        const date = new Date(dateString);
        const formattedDate = date.toLocaleString();
        return formattedDate;
    };

    const showSalesData = () => {
        if (typeof projectFilter === 'string' && projectFilter.trim() !== '') {
            const ProjectIdsArray = projectFilter.split(",").map(Number);
            if (ProjectIdsArray.includes(4) || ProjectIdsArray.includes(5)) {
                return true;
            }
        }
        return false;
    };

    const isSalesData = showSalesData();

    var primaryQuestion = '';
    var L1Question = ''
 const userCompany = GetUserData().userCompany;

    if (projectFilter.split(',').includes('1')) {
        if(isSuburban)
        {
          primaryQuestion = 'Based on your Sample Collection Experience, would you recommend Suburban Diagnostics India Pvt Limited to your family/friends ?';
        }
        else{
        primaryQuestion = 'Based on your Sample Collection Experience, would you recommend Dr. Lal PathLabs to your family/friends ?';
        }
        if (feedsData.Rating == 10) {
            L1Question = 'What did you like the most ?';
        }
        else if (feedsData.Rating == 8 || feedsData.Rating == 6) {
            L1Question = 'What as per you requires our immediate attention for improvement ?';
        }
    }
    else if (projectFilter.split(',').includes('4')) {
        if(isSuburban)
        {
        primaryQuestion = 'Based on your Contact Centre Experience, would you recommend SUBORBON to your family/friends?';

        }
        else{
        primaryQuestion = 'Based on your Contact Centre Experience, would you recommend Dr. Lal PathLabs to your family/friends?';

        }
        if (feedsData.Rating == 10) {
            L1Question = 'What did you like the most?';
        }
        else if (feedsData.Rating == 8 || feedsData.Rating == 6) {
            L1Question = 'In your opinion, what requires our immediate attention for improvement?';
        }
    }
    else if (projectFilter.split(',').includes('5')) {
        if(isSuburban)
        {
        primaryQuestion = 'How satisfied are you with the resolution provided by SUBORBON on your Query/Issue?';

        }
        else
        {
        primaryQuestion = 'How satisfied are you with the resolution provided by Dr. Lal PathLabs on your Query/Issue?';

        }
        if (feedsData.Rating == 10) {
            L1Question = 'What went well?';
        }
        else if (feedsData.Rating == 8 || feedsData.Rating == 6) {
            L1Question = 'What did not work?';
        }
    }

    return (
        IsLoading ? (
            <>
                <div className="screenLoader">
                    <ScreenLoader />
                </div>
            </>
        ) : (
            <>
                <section className='container-fluid'>
                    <div className='Page-title d-flex align-items-center'>
                        <h3 className='mb-2'>Preview</h3>
                        <div className='ms-auto'>
                            {/* <Button variant='secondary btn-sm me-2 mb-2' >Back</Button> */}
                            <a onClick={handleBackClick} className="btn btn-primary"><i class="fa fa-chevron-left" aria-hidden="true"></i> Back</a>
                            {/* <Button variant='primary btn-sm me-2 mb-2' >Read / Unread</Button> */}

                            {/* <ReactPaginate
                            previousLabel={'Prev'}
                            nextLabel={'Next'}
                            pageCount={Math.ceil(filteredData.length / itemsPerPage)}
                            marginPagesDisplayed={0}   // Hide margin pages
                            pageRangeDisplayed={0}     // Hide page numbers
                            onPageChange={handlePageClick}
                            containerClassName={'pagination d-inline-flex next-previous-only'}
                            activeClassName={'active'}
                        /> */}

                        </div>
                    </div>

                    {/* page filter */}
                    <div className='row conversation-preview mt-2'>
                        <div className='col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12'>
                            <div className='card mb-2'>
                                <div className='card-body p-2'>
                                    <div className='row g-2'>
                                        <div className='col-12 col-sm-12 col-md-8 col-lg-9 col-xl-9'>
                                            <Tab.Container defaultActiveKey="home" activeKey={key} onSelect={(k) => setKey(k)}>
                                                <Row>
                                                    <Col>
                                                        <Nav variant="tabs" className="mb-2 custom-navtabs">
                                                            <Nav.Item>
                                                                <Nav.Link eventKey="key-words">Feeds</Nav.Link>
                                                            </Nav.Item>
                                                        </Nav>
                                                    </Col>
                                                </Row>
                                                <Row>
                                                    <Col>
                                                        <Tab.Content>
                                                            <Tab.Pane eventKey="key-words">
                                                                <div className='row'>
                                                                    <div className='col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12'>
                                                                        <div className='user-info-wrapper d-inline-block d-md-flex'>
                                                                            <div className='d-flex align-items-center'>
                                                                                <div className='speedometer-chart' style={{ width: '74px', margin: '0 auto' }}>
                                                                                    <DashedCircleProgressBar value={categoryScore[feedsData.Rating]} text={categoryScore[feedsData.Rating]} color={categoryColors[feedsData.Rating]} textColor={categoryColors[feedsData.Rating]} />
                                                                                </div>
                                                                                <div className='feed-user-name'>
                                                                                    {feedsData.CustomerName} | <span className='ps-2 pe-2'>{feedsData.TouchpointName}</span>
                                                                                </div>
                                                                            </div>

                                                                            <div className='ms-auto date-time'>
                                                                                {DateFormatter(feedsData.RespondedOn)}
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                                <div className='row'>
                                                                    <div className='col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12'>
                                                                        <div className='question-wrapper'>
                                                                            <div className='row g-2'>
                                                                                <div className='col-12 col-sm-12 cl-md-7 col-lg-7 col-xl-6'>
                                                                                    <span className='point-icon'><i className='fa fa-key'></i></span>
                                                                                    {/* <span className='max-point'>{feedsData.Rating}</span> */}
                                                                                    <span className='question'>{primaryQuestion}</span>
                                                                                </div>
                                                                                <div className='col-12 col-sm-12 cl-md-5 col-lg-5 col-xl-6 text-end'>
                                                                                    {/* <span className='max-point point'>{feedsData.Rating}</span> */}
                                                                                    <span className='answer'>{ratingFeedback[feedsData.Rating]}</span>
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                        <div className='question-wrapper'>
                                                                            <div className='row g-2'>
                                                                                <div className='col-12 col-sm-12 cl-md-7 col-lg-7 col-xl-6'>
                                                                                    {/* <span className='point-icon'><i className='fa fa-key'></i></span> */}
                                                                                    {/* <span className='max-point'>10</span> */}
                                                                                    <span className='question'>{L1Question}</span>
                                                                                </div>
                                                                                <div className='col-12 col-sm-12 cl-md-5 col-lg-5 col-xl-6 text-end'>
                                                                                    {/* <span className='max-point point'>4</span> */}
                                                                                    <span className='answer'>{feedsData.L1Driver}</span>
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                        <div className={projectFilter.split(',').includes('1') ? 'question-comment' : 'd-none question-comment'}>
                                                                            <div className='row g-2'>
                                                                                <div className='col-12 col-sm-12 cl-md-7 col-lg-7 col-xl-6'>
                                                                                    {/* <span className='point-icon'></span> */}
                                                                                    <span className='question'>Is Lab No. Received</span>
                                                                                </div>
                                                                                <div className='col-12 col-sm-12 cl-md-5 col-lg-5 col-xl-6 text-end'>
                                                                                    <span className='answer'>{feedsData.IsReceiveLabNumber}</span>
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                        <div className='question-comment'>
                                                                            <div className='row g-2'>
                                                                                <div className='col-12 col-sm-12 cl-md-7 col-lg-7 col-xl-6'>
                                                                                    {/* <span className='point-icon'></span> */}
                                                                                    <span className='question'>Feedback</span>
                                                                                </div>
                                                                                <div className='col-12 col-sm-12 cl-md-5 col-lg-5 col-xl-6 text-end'>
                                                                                    <span className='answer'>{feedsData.Suggestions}</span>
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </Tab.Pane>
                                                        </Tab.Content>
                                                    </Col>
                                                </Row>
                                            </Tab.Container>
                                        </div>


                                        <div className='col-12 col-sm-12 col-md-4 col-lg-3 col-xl-3'>
                                            <Accordion className='custom-accordian'>
                                                <Accordion.Item eventKey="0">
                                                    <Accordion.Header>Profile</Accordion.Header>
                                                    <Accordion.Body>
                                                        <div className='table-responsive custom-table'>
                                                            <table className='table table-sm table-borderless'>
                                                                <tbody>
                                                                    <tr>
                                                                        <td>Name</td>
                                                                        <td>{feedsData.CustomerName}</td>
                                                                    </tr>
                                                                    {/* <tr>
                                                                    <td>Email</td>
                                                                    <td>{feedsData.Email}</td>
                                                                </tr> */}
                                                                    <tr>
                                                                        <td>Mobile No.</td>
                                                                        <td>{feedsData.Mobile}</td>
                                                                    </tr>
                                                                </tbody>
                                                            </table>
                                                        </div>
                                                    </Accordion.Body>
                                                </Accordion.Item>
                                                <Accordion.Item eventKey="1">
                                                    <Accordion.Header>Transaction</Accordion.Header>
                                                    <Accordion.Body>
                                                        <div className='table-responsive custom-table'>
                                                            <table className='table table-sm table-borderless'>
                                                                {projectFilter.split(',').includes('1') ?
                                                                    <>
                                                                        <tbody>
                                                                            <tr>
                                                                                <td>Billing Code</td>
                                                                                <td>{feedsData.BillingCode || 'NA'}</td>
                                                                            </tr>
                                                                            <tr className={projectFilter.split(',').includes('1') ? '' : 'd-none'}>
                                                                                <td>Source Of Business</td>
                                                                                <td>{feedsData.SOB || 'NA'}</td>
                                                                            </tr>
                                                                            <tr>
                                                                                <td>Request Date</td>
                                                                                <td>{GetFormattedDateTime(feedsData.RequestDate, true) || 'NA'}</td>
                                                                            </tr>
                                                                            <tr>
                                                                                <td>Response Date</td>
                                                                                <td>{GetFormattedDateTime(feedsData.RespondedOn, true) || 'NA'}</td>
                                                                            </tr>
                                                                            <tr>
                                                                                <td>Rated Language</td>
                                                                                <td>{feedsData.RatedLanguage || 'NA'}</td>
                                                                            </tr>
                                                                            <tr>
                                                                                <td>Lab Number</td>
                                                                                <td>{feedsData.LabNumber}</td>
                                                                            </tr>
                                                                            <tr>
                                                                                <td>Location Code</td>
                                                                                <td>{feedsData.LocationCode || 'NA'}</td>
                                                                            </tr>
                                                                            <tr>
                                                                                <td>Location Name</td>
                                                                                <td>{feedsData.LocationName || 'NA'}</td>
                                                                            </tr>
                                                                            {/* <tr>
                                                                    <td>Location State</td>
                                                                    <td>{feedsData.LocationName || 'NA'}</td>
                                                                </tr>
                                                                <tr>
                                                                    <td>Location City</td>
                                                                    <td>{feedsData.LocationName || 'NA'}</td>
                                                                </tr> */}
                                                                        </tbody>
                                                                    </>
                                                                    :
                                                                    <>
                                                                        <tbody>
                                                                            <tr>
                                                                                <td>Request Date Date</td>
                                                                                <td>{GetFormattedDateTime(feedsData.RequestDate, true) || 'NA'}</td>
                                                                            </tr>
                                                                            <tr>
                                                                                <td>Response Date</td>
                                                                                <td>{GetFormattedDateTime(feedsData.RespondedOn, true) || 'NA'}</td>
                                                                            </tr>
                                                                            <tr>
                                                                                <td>Rated Language</td>
                                                                                <td>{feedsData.RatedLanguage || 'NA'}</td>
                                                                            </tr>
                                                                            <tr>
                                                                                <td>Transaction Id</td>
                                                                                <td>{feedsData.TransactionId || 'NA'}</td>
                                                                            </tr>
                                                                            <tr>
                                                                                <td>Input Source</td>
                                                                                <td>{feedsData.InputSource || 'NA'}</td>
                                                                            </tr>
                                                                            <tr>
                                                                                <td>Call Type</td>
                                                                                <td>{feedsData.CallType || 'NA'}</td>
                                                                            </tr>
                                                                            <tr>
                                                                                <td>Call Sub Type</td>
                                                                                <td>{feedsData.CallSubType || 'NA'}</td>
                                                                            </tr>
                                                                            <tr>
                                                                                <td>Call Category</td>
                                                                                <td>{feedsData.CallCategory || 'NA'}</td>
                                                                            </tr>
                                                                            <tr>
                                                                                <td>Touchpoint Name</td>
                                                                                <td>{feedsData.TouchpointName}</td>
                                                                            </tr>
                                                                            <tr>
                                                                                <td>Employee Code</td>
                                                                                <td>{feedsData.EmpCode || 'NA'}</td>
                                                                            </tr>
                                                                            <tr>
                                                                                <td>Employee Name</td>
                                                                                <td>{feedsData.EmpName || 'NA'}</td>
                                                                            </tr>
                                                                            <tr>
                                                                                <td>Manager1</td>
                                                                                <td>{feedsData.Manager1 || 'NA'}</td>
                                                                            </tr>
                                                                            <tr>
                                                                                <td>Manager2</td>
                                                                                <td>{feedsData.Manager2 || 'NA'}</td>
                                                                            </tr>
                                                                            <tr>
                                                                                <td>Caseresolution Type</td>
                                                                                <td>{feedsData.CaseResolutionType || 'NA'}</td>
                                                                            </tr>
                                                                        </tbody>
                                                                    </>}
                                                            </table>
                                                        </div>
                                                    </Accordion.Body>
                                                </Accordion.Item>
                                                <Accordion.Item eventKey="3">
                                                    <Accordion.Header>Notes</Accordion.Header>
                                                    <Accordion.Body>
                                                        <div className='row'>
                                                            <div className='col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 mb-2'>
                                                                {feedsData.NoteAuthor || ''}
                                                            </div>
                                                            <div className='col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 mb-2'>
                                                                {feedsData.Note || ''}
                                                            </div>
                                                            <div className='col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 mb-2'>
                                                                {feedsData.NoteInsertionTime || ''}
                                                            </div>
                                                            <div className='col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 mb-2'>
                                                                <div className="did-floating-label-content">
                                                                    <textarea className='did-floating-input pt-2 pb-2' style={{ height: 'auto' }} rows={'3'} placeholder='Add Notes' onChange={handleNotes}></textarea>
                                                                    <div style={{ fontSize: '10px' }}><span className='text-danger'>*</span>Add Notes for internal team.</div>
                                                                </div>
                                                                <div className='text-end'>
                                                                    <Button variant='primary' onClick={handleAddNotes}>Add</Button>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </Accordion.Body>
                                                </Accordion.Item>
                                                <Accordion.Item eventKey="4">
                                                    <Accordion.Header>Status <span>Open</span></Accordion.Header>
                                                    <Accordion.Body>
                                                        <div className='row'>
                                                            <div className='col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12'>
                                                                <SearchableSelect options={statusoptions} onSelect={handleSelect} />
                                                                <div className='text-end mt-2'>
                                                                    <Button variant='primary' >Update</Button>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </Accordion.Body>
                                                </Accordion.Item>
                                                {/* <Accordion.Item eventKey="5">
                                                <Accordion.Header>Assignee</Accordion.Header>
                                                <Accordion.Body>
                                                    <div className='row'>
                                                        <div className='col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12'>
                                                        <SearchableSelect 
                                                            options={assignees.map((assignee) => ({
                                                                value: assignee.UserEmail,
                                                                label: assignee.UserEmail 
                                                            }))} 
                                                            onSelect={handleSelect} 
                                                            />
                                                            <div className='text-end mt-2'>
                                                                <Button variant='primary' >Add</Button>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </Accordion.Body>
                                            </Accordion.Item> */}
                                                {/* <Accordion.Item eventKey="6">
                                                <Accordion.Header>Followers</Accordion.Header>
                                                <Accordion.Body>
                                                    <div className='row'>
                                                        <div className='col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12'>
                                                            <SearchableSelect options={statusoptions} onSelect={handleSelect} />
                                                            <div className='text-end mt-2'>
                                                                <Button variant='primary' >Add</Button>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </Accordion.Body>
                                            </Accordion.Item> */}
                                                {/* <Accordion.Item eventKey="7">
                                                <Accordion.Header>Tag</Accordion.Header>
                                                <Accordion.Body>
                                                    <div className='row'>
                                                        <div className='col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12'>
                                                            <div className="did-floating-label-content">
                                                                <input type='text' className='did-floating-input pt-2 pb-2' placeholder='Type Tag Name' />
                                                            </div>
                                                            <div className='text-end mt-2'>
                                                                <Button variant='primary' >Add</Button>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </Accordion.Body>
                                            </Accordion.Item> */}
                                            </Accordion>
                                        </div>
                                    </div>


                                </div>
                            </div>
                        </div>
                    </div>

                </section>
            </>)
    )
}

export default FeedsPage;
